
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/surf-reports-forecasts-cams/[...geonames]",
      function () {
        return require("private-next-pages/surf-reports-forecasts-cams/[...geonames].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/surf-reports-forecasts-cams/[...geonames]"])
      });
    }
  